import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { UserIcon, LockIcon, EyeIcon, EyeOffIcon, MailIcon, ArrowLeftIcon } from 'lucide-react';
export const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isRegistering, setIsRegistering] = useState(false);
  const {
    login
  } = useAuth();
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!username.trim() || !password.trim()) {
      setError('Please enter both username and password');
      return;
    }
    const success = login(username, password);
    if (success) {
      navigate('/');
    } else {
      setError('Invalid username or password');
    }
  };
  const handleRegisterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    // This would be where the registration logic would go
    // For now, just display a message
    alert('Registration functionality not implemented');
  };
  const toggleForm = () => {
    setIsRegistering(!isRegistering);
    setError('');
  };
  return <div className="bg-white min-h-screen flex flex-col items-center justify-center p-4" data-id="element-321">
      <div className="w-full max-w-md" data-id="element-322">
        <div className="flex justify-center mb-8" data-id="element-323">
          <div className="flex items-center" data-id="element-324">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-325">
              <circle cx="20" cy="20" r="12" stroke="#333333" strokeWidth="1.5" strokeDasharray="3 2" data-id="element-326" />
              <line x1="14" y1="27" x2="11" y2="32" stroke="#333333" strokeWidth="1.5" data-id="element-327" />
              <line x1="26" y1="27" x2="29" y2="32" stroke="#333333" strokeWidth="1.5" data-id="element-328" />
              <line x1="14" y1="13" x2="11" y2="8" stroke="#333333" strokeWidth="1.5" data-id="element-329" />
              <line x1="26" y1="13" x2="29" y2="8" stroke="#333333" strokeWidth="1.5" data-id="element-330" />
              <circle cx="20" cy="20" r="2" stroke="#333333" strokeWidth="1" data-id="element-331" />
            </svg>
            <span className="ml-3 text-2xl font-bold text-gray-800" data-id="element-332">
              Partix
            </span>
          </div>
        </div>
        <div className="border border-dashed border-gray-300 rounded-lg p-6" data-id="element-333">
          {isRegistering ? <>
              <div className="flex items-center mb-6" data-id="element-334">
                <button onClick={toggleForm} className="text-gray-600 hover:text-gray-800 mr-2" data-id="element-335">
                  <ArrowLeftIcon className="h-5 w-5" data-id="element-336" />
                </button>
                <h1 className="text-xl font-bold text-gray-800 text-center flex-1 pr-7" data-id="element-337">
                  Register
                </h1>
              </div>
              {error && <div className="mb-4 p-3 bg-gray-100 border border-gray-300 text-gray-800 rounded-md" data-id="element-338">
                  {error}
                </div>}
              <form onSubmit={handleRegisterSubmit} data-id="element-339">
                <div className="mb-4" data-id="element-340">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-341">
                    Full Name
                  </label>
                  <div className="relative" data-id="element-342">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-343">
                      <UserIcon className="h-5 w-5 text-gray-400" data-id="element-344" />
                    </div>
                    <input id="name" type="text" value={name} onChange={e => setName(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-gray-500 focus:border-gray-500" placeholder="Enter your full name" data-id="element-345" />
                  </div>
                </div>
                <div className="mb-4" data-id="element-346">
                  <label htmlFor="register-email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-347">
                    Email
                  </label>
                  <div className="relative" data-id="element-348">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-349">
                      <MailIcon className="h-5 w-5 text-gray-400" data-id="element-350" />
                    </div>
                    <input id="register-email" type="email" value={email} onChange={e => setEmail(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-gray-500 focus:border-gray-500" placeholder="Enter your email" data-id="element-351" />
                  </div>
                </div>
                <div className="mb-4" data-id="element-352">
                  <label htmlFor="register-username" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-353">
                    Username
                  </label>
                  <div className="relative" data-id="element-354">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-355">
                      <UserIcon className="h-5 w-5 text-gray-400" data-id="element-356" />
                    </div>
                    <input id="register-username" type="text" value={username} onChange={e => setUsername(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-gray-500 focus:border-gray-500" placeholder="Choose a username" data-id="element-357" />
                  </div>
                </div>
                <div className="mb-4" data-id="element-358">
                  <label htmlFor="register-password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-359">
                    Password
                  </label>
                  <div className="relative" data-id="element-360">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-361">
                      <LockIcon className="h-5 w-5 text-gray-400" data-id="element-362" />
                    </div>
                    <input id="register-password" type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-gray-500 focus:border-gray-500" placeholder="Create a password" data-id="element-363" />
                    <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center" onClick={() => setShowPassword(!showPassword)} data-id="element-364">
                      {showPassword ? <EyeOffIcon className="h-5 w-5 text-gray-400" data-id="element-365" /> : <EyeIcon className="h-5 w-5 text-gray-400" data-id="element-366" />}
                    </button>
                  </div>
                </div>
                <div className="mb-6" data-id="element-367">
                  <label htmlFor="confirm-password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-368">
                    Confirm Password
                  </label>
                  <div className="relative" data-id="element-369">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-370">
                      <LockIcon className="h-5 w-5 text-gray-400" data-id="element-371" />
                    </div>
                    <input id="confirm-password" type={showConfirmPassword ? 'text' : 'password'} value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-gray-500 focus:border-gray-500" placeholder="Confirm your password" data-id="element-372" />
                    <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center" onClick={() => setShowConfirmPassword(!showConfirmPassword)} data-id="element-373">
                      {showConfirmPassword ? <EyeOffIcon className="h-5 w-5 text-gray-400" data-id="element-374" /> : <EyeIcon className="h-5 w-5 text-gray-400" data-id="element-375" />}
                    </button>
                  </div>
                </div>
                <button type="submit" className="w-full bg-gray-800 text-white py-2 px-4 rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2" data-id="element-376">
                  Create Account
                </button>
              </form>
            </> : <>
              <h1 className="text-xl font-bold text-gray-800 mb-6 text-center" data-id="element-377">
                Login
              </h1>
              {error && <div className="mb-4 p-3 bg-gray-100 border border-gray-300 text-gray-800 rounded-md" data-id="element-378">
                  {error}
                </div>}
              <form onSubmit={handleSubmit} data-id="element-379">
                <div className="mb-4" data-id="element-380">
                  <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-381">
                    Username
                  </label>
                  <div className="relative" data-id="element-382">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-383">
                      <UserIcon className="h-5 w-5 text-gray-400" data-id="element-384" />
                    </div>
                    <input id="username" type="text" value={username} onChange={e => setUsername(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-gray-500 focus:border-gray-500" placeholder="Enter username" data-id="element-385" />
                  </div>
                </div>
                <div className="mb-6" data-id="element-386">
                  <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-387">
                    Password
                  </label>
                  <div className="relative" data-id="element-388">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-389">
                      <LockIcon className="h-5 w-5 text-gray-400" data-id="element-390" />
                    </div>
                    <input id="password" type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-gray-500 focus:border-gray-500" placeholder="Enter password" data-id="element-391" />
                    <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center" onClick={() => setShowPassword(!showPassword)} data-id="element-392">
                      {showPassword ? <EyeOffIcon className="h-5 w-5 text-gray-400" data-id="element-393" /> : <EyeIcon className="h-5 w-5 text-gray-400" data-id="element-394" />}
                    </button>
                  </div>
                </div>
                <button type="submit" className="w-full bg-gray-800 text-white py-2 px-4 rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 mb-4" data-id="element-395">
                  Login
                </button>
              </form>
              <div className="relative my-6" data-id="element-396">
                <div className="absolute inset-0 flex items-center" data-id="element-397">
                  <div className="w-full border-t border-gray-300" data-id="element-398"></div>
                </div>
                <div className="relative flex justify-center text-sm" data-id="element-399">
                  <span className="px-2 bg-white text-gray-500" data-id="element-400">
                    Or continue with
                  </span>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3 mb-6" data-id="element-401">
                <button type="button" className="flex items-center justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2" data-id="element-402">
                  <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24" data-id="element-403">
                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-404" />
                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-405" />
                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-406" />
                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-407" />
                  </svg>
                  Google
                </button>
                <button type="button" className="flex items-center justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2" data-id="element-408">
                  <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="black" data-id="element-409">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" data-id="element-410" />
                  </svg>
                  Apple
                </button>
              </div>
              <div className="text-center" data-id="element-411">
                <span className="text-sm text-gray-600" data-id="element-412">
                  Don't have an account?{' '}
                </span>
                <button type="button" onClick={toggleForm} className="text-sm font-medium text-gray-800 hover:underline focus:outline-none" data-id="element-413">
                  Register
                </button>
              </div>
            </>}
        </div>
      </div>
    </div>;
};